import { render, staticRenderFns } from "./AttendCompanyAddOrUpdate.vue?vue&type=template&id=45d13ee1&scoped=true&"
import script from "./AttendCompanyAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./AttendCompanyAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d13ee1",
  null
  
)

export default component.exports